import React, {useState, useEffect} from 'react'
import {  Container, Row, Col } from 'react-bootstrap'
import loginregistration from "../../../../assets/build/loginregistration.mp4"
import PlayOverlayVideo from "../../../../PlayOverlayVideo"


import "../buidl.css";


function LoginRegVd() {

   const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 768);
  
    useEffect(() => {
      const handleResize = () => {
        setIsSmallScreen(window.innerWidth <= 768);
      };
  
      window.addEventListener('resize', handleResize);
  
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, []);

    // const handleContextMenu = (e) => {
    //   e.preventDefault(); // Disable right-click
    // };


  return (
    <Container 
    fluid 
    className='container-section' 
    style={{
      backgroundColor:"#FFFFFF",
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: isSmallScreen ? 'auto' : '100vh',
      paddingBottom: isSmallScreen ? '5rem' : 'auto',
       paddingTop: isSmallScreen ? '5rem' : 'auto',
      }}>
      <Row style={{ height: "auto", width: "100%"}}>
        <Col xs={12} md={4} lg={4}> 
         <h2 style={{fontWeight:"bold",fontSize:"2rem"}}>Login and<br /> Registration Flow</h2>
         <div style={{fontWeight:"regular",fontSize:"0.85rem"}} >Builder</div>
         </Col>
        <Col xs={12} md={8} lg={8}>
      <div style={{ Width: "100%",height:"100", margin: "auto" }}>
      <PlayOverlayVideo src={loginregistration} />
    </div>
        </Col>
      </Row>
    </Container>
    
     
    
  )
}

export default LoginRegVd